<template>
<div class="introduce-image">
    <v-card  class="introduce-page">
      <v-form style="width: 80%;margin: 20px auto auto;" validation ref="v-form" v-model="valid">
        <div class="input-image">
          <v-file-input
            v-model="files"
            class="input"
            chips
            placeholder="عکس کاور  معرفی را وارد کنید"
            accept="image/png, image/jpeg, image/bmp"
            prepend-icon="mdi-camera"
            hide-details
            v-on:change="showImage($event)"
            v-on:click:clear="deleteImage"
          ></v-file-input>
        <v-img style="max-width: 200px" width="200" height="150" :src="image"></v-img>
        </div>
         <v-textarea
          class="text-input"
          counter
          label="متن مرفی مورد نظر خود را وارد کنید"
          row-height="5"
          :rules="[rules1]"
          v-model="text"
          rows="3"
        ></v-textarea>

      </v-form>
      <div class="buttons">
        <v-btn :loading="sendLoading" v-if="!isEdit" class="button-style"  :disabled="!valid" @click="send()">فرستادن</v-btn>
        <v-btn :loading="editLoading" v-else class="button-style"  :disabled="!valid" @click="update()">ویرایش</v-btn>
      </div>
      <div class="image">
        <v-row>
          <v-col>
            <p style="font-weight: bold;font-size: 18px">عکس کاور اصلی :</p>
            <v-img v-if="file!==''" width="300" height="200" lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" style="max-width: 400px; max-height: 250px" :src="baseUrl +file">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
        </v-row>

      </div>

    </v-card>
    <introduce-units-and-features></introduce-units-and-features>
</div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import {toBase64} from "../../../plugins/toBase64";
  import {setIntroduction,putIntroduction} from '../../../api/introduce'
  import introduceUnitsAndFeatures from '../component/IntroduceComponent/introduceUnitsAndFeatures'

  export default {
        name: "IntroducePage",
        components:{
          introduceUnitsAndFeatures
        },
        data :()=>({
          files:[],
          baseUrl:'',
          id:'',
          cover:[],
          videoPath:[],
          image:'',
          file:'',
          coverImage:'',
          text:'',
          valid:true,
          isEdit:false,
          sendLoading:false,
          editLoading:false,
          rules1: v =>{
            if(v !== '' && v.length <=250)
            {
              return true
            }
            else
            {
              return `متن وارد شده باید کمتر از ${250} کاراکتر باشد`
            }
          },
        }),
      methods:{
        showImage(e){
          if(e) {
            this.image = URL.createObjectURL(e)
          }
        },
        showCover(e)
        {
          if(e) {
            this.coverImage = URL.createObjectURL(e)
          }
        },
        deleteImage()
        {
          this.image = ''
        },

       async send(){
           this.sendLoading = true
           let img = this.files ? await  toBase64(this.files) : null
           let cov = this.cover ? await  toBase64(this.cover): null
           let params = {
             file:img,
             text:this.text
           }
           setIntroduction(params).then(()=>{
             this.getIntroduceReq()
             this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
           }).catch(()=>{
             this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
           })
          this.sendLoading = false
       },
       async  update(){
          this.editLoading = true
          let img = this.files ? await  toBase64(this.files) : null
          let cov = this.cover ? await  toBase64(this.cover): null
          let params = {
            id:this.id,
            file:img,
            text:this.text
          }
        await putIntroduction(params,this.id).then(()=>{
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
         await             this.getIntroduceReq()

         this.file = this.originalIntroduce[0].file
         this.editLoading = false
       },
        ...mapActions({
          getIntroduceReq:'introduceStore/fetchIntroduce',
          snackBarAction:'snackBar/snackBarAction',
          setLoading : 'setLoading'

        }),
      },
      computed: {
        ...mapGetters({
          originalIntroduce: 'introduceStore/get_introduce',
        })
      },
     async mounted() {
        this.setLoading(true)
        this.baseUrl = process.env.VUE_APP_BASE_URL
         try {
           await this.getIntroduceReq()
           if (this.originalIntroduce.length !== 0) {
             this.isEdit = true
             this.text = this.originalIntroduce[0].text
             this.id = this.originalIntroduce[0].id
             this.file = this.originalIntroduce[0].file
           }

         }catch(e){
          this.text = ''
          this.id=0
         }
        this.setLoading(false)
       }
    }
</script>

<style scoped>
 .introduce-page{
   width: 86.5%;
   margin: 0 auto;
   padding: 50px 0;
 }
  .input{
    margin-top: 0;
  }
  .v-text-field{
    margin: 0;
    padding-top: 0;
  }
  .text-input{
    margin-top: 20px;
  }
  .image{
    width: 86%;
    margin: auto;
  }
  .buttons{
    width: 86.5%;
    margin: 40px auto 40px;
    direction: ltr;
  }

 .input-image{

   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 2rem;
 }
 .input{
   max-width: 300px;
 }
</style>
